export default {
  actions: {
    activateCadasterLayer: 'Visualitzar capa cadastral',
    minimize: 'Minimitza',
    maximize: 'Maximitza',
    openNewTab: 'Obre en una nova pestanya'
  },
  names: {
    image: 'Imatge',
    keywords: 'Cerques relacionades',
    lateral: 'Lateral',
    map: 'Mapa',
    next: 'Següent',
    panorama: 'Panorama',
    pointCloud: 'Núvol de punts',
    previous: 'Anterior',
    projection: 'Projecció',
    tools: 'Eines',
    home: 'Inici',
    baseMap: 'Mapa base',
    moveForward: 'Avançar',
    moveBackwards: 'Retrocedir'
  },
  messages: {
    referenceNotFound: 'No s\'ha trobat la referència'
  },
  tools: {
    auth: {
      loggedToMapia: 'La sessió de Mapia s\'ha iniciat correctament'
    },
    downloads: {
      headerName: 'Descàrregues',
      title: 'Centre de descàrregues'
    },
    language: {
      headerName: 'Idioma'
    },
    opendata: {
      headerName: 'Open Data'
    },
    geovideos: {
      headerName: 'Geovideo',
      description: 'No s\'ha trobat cap vídeo en aquest punt.',
      activateCenterMap: 'Centrar mapa',
      deactivateCenterMap: 'Desactivar centrar mapa',
      clickMapDescription: 'Fes clic sobre el mapa per accedir als vídeos georeferenciats.',
      additionalInfo: 'Informació addicional',
      showAdditionalInfo: 'Mostrar informació addicional',
      second: 'Segon',
      stepForwardBackward: 'Recórrer distància (m)',
      takePicture: 'Capturar vista actual',
      reproductionSpeed: 'Velocitat de reproducció'
    },
    panorama: {
      addAmbit: 'Capa d\'àmbits',
      addAmbitCaption: 'Afegeix una capa amb els àmbits on hi ha panorames',
      addLayer: 'Capa panorames',
      addLayerCaption: 'Afegeix una capa amb els punts on hi ha panorames',
      headerName: 'Entorn 3D',
      title: 'Fotografies panoràmiques i núvols de punts.',
      help: 'Fes clic sobre el mapa per accedir a la fotografia panoràmica i als núvols de punts obtinguts mitjançant Mobile Mapping.',
      centerMap: 'Centra mapa',
      noDataError: 'En aquesta localització no s\'han pogut trobar dades.',
      disablePano: 'Desactiva panorama',
      enablePano: 'Activa panorama',
      enablePanoDescription: 'Activa/desactiva el visor de panorames',
      enableLateral: 'Activa imatge lateral',
      disable3D: 'Desactiva 3D',
      enable3D: 'Activa 3D',
      enable3DDescription: 'Activa/desactiva el visor de núvols de punts',
      unsync3D: 'Desincronitza 3D',
      sync3D: 'Sincronitza 3D',
      openPano: 'Obre panorama',
      openPanoCaption: 'Obre el panorama en una altra pestanya',
      openPointCloud: 'Obre núvol de punts',
      openPointCloudCaption: 'Obre el núvol de punts en una altra pestanya',
      rotateLeft: 'Gira el panorama 90º a l\'esquerra',
      rotate180: 'Gira el panorama 180º',
      rotateRight: 'Gira el panorama 90º a la dreta',
      mustLogin: 'Inicia sessió per visualitzar els panorames',
      infoCampaign: 'Informació campanya activa',
      descriptionCampaign: 'Descripció campanya',
      zoneCampaign: 'Zona',
      dateCampaign: 'Dates campanya',
      startCampaign: 'Inici campanya',
      endCampaign: 'Final campanya',
      splitVertially: 'Divideix verticalment',
      splitHorizontaly: 'Divideix horitzontalment',
      drawingNavigationPanel: 'Navegació automàtica',
      drawingNavigationPanelDescription: 'Obra la finestra de navegació automàtica',
      generateNewRoute: 'Generar nou recorregut',
      playlist: 'Llista de reproducció',
      reversePlaylist: 'Invertir sentit del recorregut',
      removePlaylist: 'Esborrar el recorregut',
      drawingNavigationPanelInfo: 'Dibuixa una línia per generar el recorregut pel qual vols navegar. Fes doble click per parar de dibuixar.',
      drawingNavigationPanelInfo2: 'Fes click a "Generar nou recorregut" per dibuixar sobre el mapa el recorregut pel qual vols navegar.',
      drawingNavigationPanelInfo3: 'Fes clic al botó de "Play" per iniciar el recorregut.',
      playPlaylist: 'Navega pel recorregut',
      stopPlaying: 'Aturar reproducció',
      timePerPoint: 'Temps per punt en segons',
      stepBetweenPoints: 'Salt entre punts'
    },
    addCustomLayer: {
      headerName: 'Afegir capa',
      title: 'Afegir capa personalitzada',
      layerFormat: 'Escull format nova capa',
      layerFormatOptions: [
        'WMS',
        'TMS',
        'GeoJSON',
        'GML'
      ],
      layerName: 'Escriu el nom de la capa',
      layerURL: 'Escriu la URL de la capa o servei',
      properties: 'Propietats',
      layerWMSLayers: 'Indica les capes del WMS: capa1, capa2, ...',
      layerWMSLayersHint: 'Utilitza la coma per separar cada capa.',
      layerProjection: 'Projecció:',
      layerWMSSingleImage: 'Carregar WMS sense tessel·lar, utilitzant una sola imatge',
      layerTMSInvert: "Invertir les tessel·les en l'eix de les Y",
      geojsonColor: 'Selecciona color linia',
      geojsonFillColor: 'Selecciona color replè',
      geojsonWeight: 'Gruix',
      geojsonWeightHint: 'Només números',
      geojsonOpacity: 'Opacitat',
      geojsonOpacityHint: 'Només números del 0 al 1',
      addButton: 'Afegir capa al mapa'
    },
    search: {
      advanced: {
        title: 'Cerca avançada',
        optionsLabel: 'Selecciona què vols cercar',
        layers: 'Capes del catàleg',
        address: 'Adreça',
        addressICGC: 'Adreça (ICGC)',
        municipality: 'Municipi (opcional)',
        refcad: 'Referència cadastral',
        coordinates: 'Coordenades',
        pkICGC: 'Punt quilomètric (ICGC)',
        layerSearchLabel: 'Nom de la capa',
        search: 'Cerca',
        roadSearchLabel: 'Via (Ex: AP-7)',
        pkSearchLabel: 'Punt quilomètric (Ex: 123)',
        epsgLabel: 'SRS',
        latitude: 'Latitud',
        longitude: 'Longitud',
        x: 'X',
        y: 'Y',
        street: 'Carrer',
        streetNumber: 'Número'
      }
    },
    panoramasIncidence: {
      requiredField: 'Camp obligatori',
      descriptionMissing: 'El tipus d\'incidència "Altres" requereix una descripció',
      notifyIncidence: 'Notifica incidència',
      incidenceType: 'Tipus d\'incidència',
      incidenceOptions: [
        'Informació sensible sense ofuscar',
        'Error a la imatge panoràmica',
        'Error al núvol de punts',
        'Orientació panorama/núvol de punts no coincideix',
        'Altres'
      ]
    }
  }
}
